<template>
  <div class="pwc-speaker-div">
    <van-image
      v-if="cAvatar"
      class="pwc-speaker-img"
      :src="cAvatar"
    />
    <van-cell-group :border="false">
      <van-cell :title="cName" />
      <van-cell :title="cTitle" />
      <van-cell :title="cCompany" />
      <van-cell title="">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div slot="label" style="padding-left:10%; padding-right:10%; text-align:left;" v-html="cDescription" />
      </van-cell>

    </van-cell-group>

  </div>

</template>

<script>
import { Image, CellGroup, Cell } from 'vant'
// import { loading } from '@/mixin'
// import { store, logic } from '../common/mixin/logic'
import getConfig from '@/config/index'
export default {
  components: {
    VanImage: Image,
    VanCellGroup: CellGroup,
    VanCell: Cell
  },
  // mixins: [loading, store, logic],
  props: {
    profile: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    cName() {
      return this.profile.name
    },
    cAvatar() {
      return getConfig().PUBLIC_URL + this.profile.portraitUrl
    },
    cCompany() {
      return this.profile.company
    },
    cTitle() {
      return this.profile.title
    },
    cDescription() {
      const arr = (this.profile.introduction || '').split('\n')
      let appendString = '<ul>'
      for (const key in arr) {
        appendString = appendString + '<li>' + arr[key] + '</li>'
      }
      appendString = appendString + '</ul>'
      return appendString
    }
  }

}
</script>

<style lang="scss" scoped>

    $pwc-avatar-size:160px;
.pwc-speaker-div{
    text-align: center;
}
.pwc-speaker-img{
    margin:auto;
  box-sizing: border-box;
  position:relative;
  height:$pwc-avatar-size;
  width:$pwc-avatar-size;
  border-radius: 50%;
  overflow:hidden;
  display:flex;
  justify-content:center;
  align-items: center;
  img {
    height: 160px;
    width: 160px;
  }
}
  .van-cell:not(:last-child)::after {
    display:none !important;
}
</style>
